import _ from 'lodash';
import envUtils from './env';

export const SUPPORT_EXPERT_ID = '5afd8336b5f01f4cdf59c708';
export const SUPPORT_PHONE_NUMBER = envUtils.pick(
  '+16282502606',
  '+16282502615',
  '+16282502574',
);
export const STRIPE_PUBLIC_KEY = envUtils.pick(
  'pk_live_TuPSgXl8KA8joTLrNVuD7iU6',
  'pk_test_AOrq7JiJpcUjZCJYAEFf62GZ',
  'pk_test_AOrq7JiJpcUjZCJYAEFf62GZ',
);
export const PAYPAL_CLIENT_ID = envUtils.pick(
  'AQHS1XnhfATiue1f9lJ-7AFXyh2La2so3p6VNiPqR0L8GPdtjMJfp-6ZgdyD9d9sBDo-iZeOQvF0u6Oo',
  'Ad04q1VWqob69jqyEqECPs2v9zquG4gAPw1-epiYSYXOC0wNCgTPTV6a2OWTKQfG9IqUGHKJiJlSjP5P',
  'Ad04q1VWqob69jqyEqECPs2v9zquG4gAPw1-epiYSYXOC0wNCgTPTV6a2OWTKQfG9IqUGHKJiJlSjP5P',
);

export const EXPERT_LEVEL_SWITCH = 1675807137112; // Feb 7th, 2023 11pm CPH time
export const WEEKLY_CLAIM_LIMIT = 10;
export const SKIP_REASONS = [
  { text: 'Too Busy', value: 'TOO_BUSY' },
  { text: 'Not My Skills', value: 'DOESNT_MATCH_MY_SKILLS' },
  { text: 'Not Enough Detail', value: 'NOT_ENOUGH_DETAIL' },
  { text: 'Low Budget', value: 'LOW_BUDGET' },
  { text: 'Not Interested', value: 'NOT_INTERESTED_IN_PROJECT' },
  { text: 'Not Possible', value: 'NOT_POSSIBLE' },
  { text: 'Spam', value: 'SPAM' },
  { text: 'Specific Expert', value: 'SPECIFIC_EXPERT' },
  { text: 'ST Support', value: 'ST_SUPPORT' },
  { text: 'Not English', value: 'NOT_ENGLISH' },
  {
    text: 'Unreasonable Expectations',
    value: 'UNREASONABLE_PROJECT_EXPECTATIONS',
  },
  { text: 'Timeline Issue', value: 'DEADLINE_TOO_QUICK' },
  {
    text: 'Bad Past Experience',
    value: 'NEGATIVE_PAST_EXPERIENCE_WITH_CLIENT',
  },
  { text: 'Other', value: 'OTHER' },
];

export const DANGER_ZONE_REMOVAL_REASONS = [
  { label: 'Sent prefab link', value: 'HQ_REWRITE_REQUEST ' },
  {
    label: 'Client submitted prefab',
    value: 'CLIENT_SUBMITTED_PREFAB',
  },
  { label: 'Project approved successfully', value: 'PROJECT_APPROVED' },
  { label: 'Canceled by HQ', value: 'CANCELED_BY_HQ' },
  { label: 'Client Refunded', value: 'CLIENT_REFUNDED' },
  { label: 'Canceled after 24 hours', value: 'CANCELED_AFTER_24_HOURS' },
  { label: 'Canceled by Client', value: 'CANCELED_BY_CLIENT' },
  { label: 'Client Reviewing Quote', value: 'CLIENT_REVIEWING_QUOTE' },
  {
    label: 'Expert working on requested changes',
    value: 'EXPERT_WORKING_ON_REQUESTED_CHANGES',
  },
  {
    label: 'Automatic Payment captured after 72 hours',
    value: 'AUTOMATIC_PAYMENT_CAPTURED_AFTER_72_HOURS',
  },
  {
    label: 'Payment captured after failure',
    value: 'PAYMENT_CAPTURED_AFTER_FAILURE',
  },
  {
    label: 'Client paid via paypal / invoice',
    value: 'CLIENT_PAID_VIA_PAYPAL_OR_INVOICE',
  },
  {
    label: 'Client working with another agent',
    value: 'CLIENT_WORKING_WITH_ANOTHER_AGENT',
  },
  { label: 'Project Transferred', value: 'PROJECT_TRANSFERRED' },
  { label: 'Client Unresponsive', value: 'CLIENT_UNRESPONSIVE' },
  { label: 'Issue resolved in chat', value: 'ISSUE_RESOLVED_IN_CHAT' },
  {
    label: 'Client asking clarifying questions',
    value: 'CLIENT_ASKING_CLARIFYING_QUESTIONS',
  },
  {
    label: 'Expert asking clarifying questions',
    value: 'EXPERT_ASKING_CLARIFYING_QUESTIONS',
  },
  {
    label: 'Lorem HQ asking clarifying questions',
    value: 'LOREM_HQ_ASKING_CLARIFYING_QUESTIONS',
  },
  { label: 'Spam / Junk Request', value: 'SPAM_OR_JUNK_REQUEST' },
  { label: 'Duplicate request', value: 'DUPLICATE_REQUEST' },
  { label: 'Other', value: 'OTHER' },
];

export const EXPERIENCE_OPTIONS = [
  {
    label: 'Senior (only)',
    value: 'SENIOR_ONLY',
  },
];
export const FOCUS_OPTIONS = [
  {
    label: 'Web Development',
    person: 'Shopify Developer',
    value: 'FOCUS_WEB_DEVELOPMENT',
    what: 'Full-stack devs, Headless devs, CRO devs, website speed experts, Shopify app devs, and more.',
  },
  {
    label: 'Design',
    person: 'Designer',
    value: 'FOCUS_DESIGN',
    what: 'UI / UX designers, Email designers, Brand designers, CRO experts, and more.',
  },
  {
    label: 'Marketing',
    person: 'Marketer',
    value: 'FOCUS_MARKETING',
    what: 'Paid marketing experts, Email and SMS marketers, Retention marketers, Klaviyo experts, Copywriters, and more.',
  },
  {
    label: 'eComm Management',
    person: 'eComm Manager',
    value: 'FOCUS_MANAGER',
    what: 'Ongoing site maintenance, Operations, Project management, and more.',
  },
];

export const TOOL_OPTIONS = _.sortBy(
  [
    {
      label: 'Aftership',
      value: 'TOOL_AFTERSHIP',
    },
    {
      label: 'Algolia',
      value: 'TOOL_ALGOLIA',
    },
    {
      label: 'Alloy',
      value: 'TOOL_ALLOY',
    },
    {
      label: 'Awtomic',
      value: 'TOOL_AWTOMATIC',
    },
    {
      label: 'Amazon',
      value: 'TOOL_AMAZON',
    },
    {
      label: 'BigCommerce',
      value: 'TOOL_BIGCOMMERCE',
    },
    {
      label: 'Bold',
      value: 'TOOL_BOLD',
    },
    {
      label: 'Braintree',
      value: 'TOOL_BRAINTREE',
    },
    {
      label: 'Builder.io',
      value: 'TOOL_BUILDERIO',
    },
    {
      label: 'Carro',
      value: 'TOOL_CARRO',
    },
    {
      label: 'CartHook',
      value: 'TOOL_CARTHOOK',
    },
    {
      label: 'Chargebee',
      value: 'TOOL_CHARGEBEE',
    },
    {
      label: 'Clearco',
      value: 'TOOL_CLEARCO',
    },
    {
      label: 'Contentful',
      value: 'TOOL_CONTENTFUL',
    },
    {
      label: 'Elevar',
      value: 'TOOL_ELEVAR',
    },
    {
      label: 'Facebook Ads',
      value: 'TOOL_FACEBOOK_ADS',
    },
    {
      label: 'Friendbuy',
      value: 'TOOL_FRIENDBUY',
    },
    {
      label: 'FullStory',
      value: 'TOOL_FULLSTORY',
    },
    {
      label: 'Google Adwords',
      value: 'TOOL_GOOGLE_ADWORDS',
    },
    {
      label: 'Google Analytics',
      value: 'TOOL_GOOGLE_ANALYTICS',
    },
    {
      label: 'Google Search Console',
      value: 'TOOL_GOOGLE_SEARCH_CONSOLE',
    },
    {
      label: 'Google Tag Manager',
      value: 'TOOL_GOOGLE_TAG_MANAGER',
    },
    {
      label: 'Gorgias',
      value: 'TOOL_GORGIAS',
    },
    {
      label: 'Hotjar',
      value: 'TOOL_HOTJAR',
    },
    {
      label: 'Hubspot',
      value: 'TOOL_HUBSPOT',
    },
    {
      label: 'Hydrogen',
      value: 'TOOL_HYDROGEN',
    },
    {
      label: 'Intercom',
      value: 'TOOL_INTERCOM',
    },
    {
      label: 'Iterable',
      value: 'TOOL_ITERABLE',
    },
    {
      label: 'Judge Me',
      value: 'TOOL_JUDGE_ME',
    },
    {
      label: 'Junip',
      value: 'TOOL_JUNIP',
    },
    {
      label: 'Klaviyo',
      value: 'TOOL_KLAVIYO',
    },
    {
      label: 'Loox',
      value: 'TOOL_LOOX',
    },
    {
      label: 'Loyalty Lion',
      value: 'TOOL_LOYALTY_LION',
    },
    {
      label: 'Magento',
      value: 'TOOL_MAGENTO',
    },
    {
      label: 'MailChimp',
      value: 'TOOL_MAILCHIMP',
    },
    {
      label: 'Mixpanel',
      value: 'TOOL_MIXPANEL',
    },
    {
      label: 'Nacelle',
      value: 'TOOL_NACELLE',
    },
    {
      label: 'Netlify',
      value: 'TOOL_NETLIFY',
    },
    {
      label: 'Next.js',
      value: 'TOOL_NEXTJS',
    },
    {
      label: 'Octane AI',
      value: 'TOOL_OCTANE_AI',
    },
    {
      label: 'Oddit',
      value: 'TOOL_ODDIT',
    },
    {
      label: 'Okendo',
      value: 'TOOL_OKENDO',
    },
    {
      label: 'Omnisend',
      value: 'TOOL_OMNISEND',
    },
    {
      label: 'Optimizely',
      value: 'TOOL_OPTIMIZELY',
    },
    {
      label: 'PageFly',
      value: 'TOOL_PAGEFLY',
    },
    {
      label: 'Pixel Union',
      value: 'TOOL_PIXEL_UNION',
    },
    {
      label: 'Postscript',
      value: 'TOOL_POSTSCRIPT',
    },
    {
      label: 'Prismic',
      value: 'TOOL_PRISMIC',
    },
    {
      label: 'Privy',
      value: 'TOOL_PRIVY',
    },
    {
      label: 'Rebuy',
      value: 'TOOL_REBUY',
    },
    {
      label: 'ReCharge',
      value: 'TOOL_RECHARGE',
    },
    {
      label: 'Refersion',
      value: 'TOOL_REFERSION',
    },
    {
      label: 'Sanity',
      value: 'TOOL_SANITY',
    },
    {
      label: 'Segment',
      value: 'TOOL_SEGMENT',
    },
    {
      label: 'Sendgrid',
      value: 'TOOL_SENDGRID',
    },
    {
      label: 'ShipBob',
      value: 'TOOL_SHIPBOB',
    },
    {
      label: 'Shippo',
      value: 'TOOL_SHIPPO',
    },
    {
      label: 'ShipStation',
      value: 'TOOL_SHIPSTATION',
    },
    {
      label: 'Shogun',
      value: 'TOOL_SHOGUN',
    },
    {
      label: 'Skio',
      value: 'TOOL_SKIO',
    },
    {
      label: 'Skubana',
      value: 'TOOL_SKUBANA',
    },
    {
      label: 'Smartrr',
      value: 'TOOL_SMARTRR',
    },
    {
      label: 'Smile IO',
      value: 'TOOL_SMILE_IO',
    },
    {
      label: 'Squarespace',
      value: 'TOOL_SQUARESPACE',
    },
    {
      label: 'Stamped.io',
      value: 'TOOL_STAMPEDIO',
    },
    {
      label: 'Stord',
      value: 'TOOL_STORD',
    },
    {
      label: 'Swell',
      value: 'TOOL_SWELL',
    },
    {
      label: 'TikTok Ads',
      value: 'TOOL_TIKTOK_ADS',
    },
    {
      label: 'Triple Whale',
      value: 'TOOL_TRIPLE_WHALE',
    },
    {
      label: 'Typeform',
      value: 'TOOL_TYPEFORM',
    },
    {
      label: 'Unbounce',
      value: 'TOOL_UNBOUNCE',
    },
    {
      label: 'Vercel',
      value: 'TOOL_VERCEL',
    },
    {
      label: 'Webflow',
      value: 'TOOL_WEBFLOW',
    },
    {
      label: 'Wix',
      value: 'TOOL_WIX',
    },
    {
      label: 'Wonderment',
      value: 'TOOL_WONDERMENT',
    },
    {
      label: 'WooCommerce',
      value: 'TOOL_WOOCOMMERCE',
    },
    {
      label: 'WordPress',
      value: 'TOOL_WORDPRESS',
    },
    {
      label: 'Yotpo',
      value: 'TOOL_YOTPO',
    },
    {
      label: 'Zendesk',
      value: 'TOOL_ZENDESK',
    },
    {
      label: 'Archtype Themes',
      value: 'TOOL_ARCHTYPE_THEMES',
    },
    {
      label: 'Switch Themes',
      value: 'TOOL_SWITCH_THEMES',
    },
    {
      label: 'Smart Themes',
      value: 'TOOL_SMART_THEMES',
    },
    {
      label: 'Troop Themes',
      value: 'TOOL_TROOP_THEMES',
    },
    {
      label: 'React.js',
      value: 'TOOL_REACTJS',
    },
    {
      label: 'Vue.js',
      value: 'TOOL_VUEJS',
    },
    {
      label: 'Replo',
      value: 'TOOL_REPLO',
    },
    {
      label: 'Figma',
      value: 'TOOL_FIGMA',
    },
    {
      label: 'KnoCommerce',
      value: 'TOOL_KNOCOMMERCE',
    },
    {
      label: 'Upscribe',
      value: 'TOOL_UPSCRIBE',
    },
    {
      label: 'Ordergroove',
      value: 'TOOL_ORDERGROOVE',
    },
    {
      label: 'Loop Subscriptions',
      value: 'TOOL_LOOP_SUBSCRIPTIONS',
    },
    {
      label: 'Social Snowball',
      value: 'TOOL_SOCIAL_SNOWBALL',
    },
    {
      label: 'Lantern',
      value: 'TOOL_LANTERN',
    },
    {
      label: 'Maestroo',
      value: 'TOOL_MAESTROO',
    },
    {
      label: 'Attentive',
      value: 'TOOL_ATTENTIVE',
    },
    {
      label: 'Orbit',
      value: 'TOOL_ORBIT',
    },
  ],
  'label',
);

export const INDUSTRY_OPTIONS = _.sortBy(
  [
    {
      label: 'Fashion & Accessories',
      value: 'INDUSTRY_FASHION',
    },
    {
      label: 'Health, Beauty & Wellness',
      value: 'INDUSTRY_HEALTH',
    },
    {
      label: 'Food & Beverage',
      value: 'INDUSTRY_FOOD',
    },
    {
      label: 'Home & Furniture',
      value: 'INDUSTRY_HOME',
    },
    {
      label: 'Toys, Games, Kids',
      value: 'INDUSTRY_TOYS',
    },
    {
      label: 'Outdoor & Sporting',
      value: 'INDUSTRY_OUTDOOR',
    },
    {
      label: 'Pets',
      value: 'INDUSTRY_PETS',
    },
    {
      label: 'Media & Education',
      value: 'INDUSTRY_MEDIA',
    },
    {
      label: 'Technology, Software',
      value: 'INDUSTRY_TECHNOLOGY',
    },
    {
      label: 'Travel, Hospitality',
      value: 'INDUSTRY_TRAVEL',
    },
    {
      label: 'Automotive',
      value: 'INDUSTRY_AUTOMOTIVE',
    },
    {
      label: 'Fine Art',
      value: 'INDUSTRY_ART',
    },
    {
      label: 'Jewelry',
      value: 'INDUSTRY_JEWELRY',
    },
  ],
  'label',
);

export const PROBLEM_OPTIONS = _.sortBy(
  [
    {
      label: 'Increase Conversion Rate',
      value: 'PROBLEM_CONVERSION',
    },
    {
      label: 'Increase Average Order Value (AOV)',
      value: 'PROBLEM_AOV',
    },
    {
      label: 'Boost Customer Retention & Loyalty',
      value: 'PROBLEM_RETENTION',
    },
    {
      label: 'Expand Customer Acquisition Channels',
      value: 'PROBLEM_CAC',
    },
    {
      label: 'Grow Email & SMS List',
      value: 'PROBLEM_LISTS',
    },
    {
      label: 'Improve Ad Performance',
      value: 'PROBLEM_ADS',
    },
    {
      label: 'Increase Organic Traffic & SEO',
      value: 'PROBLEM_ORGANIC',
    },
    {
      label: 'Optimize Website Speed & Performance',
      value: 'PROBLEM_SPEED',
    },
    {
      label: 'Streamline Fulfillment & Shipping',
      value: 'PROBLEM_FULFILLMENT',
    },
    {
      label: 'Improve brand Identity and aesthetics',
      value: 'PROBLEM_BRAND',
    },
    {
      label: 'Improve general UI / UX',
      value: 'PROBLEM_UIUX',
    },
    {
      label: 'Create Engaging Content & Storytelling',
      value: 'PROBLEM_CONTENT',
    },
  ],
  'label',
);

export const SKILL_OPTIONS = _.sortBy(
  [
    {
      label: 'Analytics / Tracking',
      value: 'SKILL_ANALYTICS_TRACKING',
    },
    {
      label: 'Brand Design',
      value: 'SKILL_BRAND_DESIGN',
    },
    {
      label: 'Business Strategy',
      value: 'SKILL_BUSINESS_STRATEGY',
    },
    {
      label: 'Copywriting',
      value: 'SKILL_COPYWRITING',
    },
    {
      label: 'CRO (strategy)',
      value: 'SKILL_CRO_STRATEGY',
    },
    {
      label: 'CRO (technical implementation)',
      value: 'SKILL_CRO_TECHNICAL_IMPLEMENTATION',
    },
    {
      label: 'Custom Shopify App Development',
      value: 'SKILL_CUSTOMER_SHOPIFY_APP_DEVELOPMENT',
    },
    {
      label: 'Email Design',
      value: 'SKILL_EMAIL_DESIGN',
    },
    {
      label: 'Email Development (custom code)',
      value: 'SKILL_EMAIL_DEVELOPMENT_CUSTOM_CODE',
    },
    {
      label: 'Email Marketing',
      value: 'SKILL_EMAIL_MARKETING',
    },
    {
      label: 'Headless Builds',
      value: 'SKILL_HEADLESS_BUILDS',
    },
    {
      label: 'Illustration',
      value: 'SKILL_ILLUSTRATION',
    },
    {
      label: 'Paid Marketing',
      value: 'SKILL_PAID_MARKETING',
    },
    {
      label: 'Photography',
      value: 'SKILL_PHOTOGRAPHY',
    },
    {
      label: 'Store Management',
      value: 'SKILL_PROJECT_MANAGEMENT',
    },
    {
      label: 'SEO (strategy)',
      value: 'SKILL_SEO_STRATEGY',
    },
    {
      label: 'SEO (technical implementation)',
      value: 'SKILL_SEO_TECHNICAL_IMPLEMENTATION',
    },
    {
      label: 'Site Speed Optimization (Dev)',
      value: 'SKILL_SITE_SPEED_OPTIMIZATION_DEV',
    },
    {
      label: 'Site Speed Optimization (Marketing)',
      value: 'SKILL_SITE_SPEED_OPTIMIZATION_MARKETING',
    },
    {
      label: 'Supply Chain',
      value: 'SKILL_SUPPLY_CHAIN',
    },
    {
      label: 'UX / UI',
      value: 'SKILL_UX_UI',
    },
    {
      label: 'Full Website Design',
      value: 'SKILL_FULL_WEBSITE_DESIGN',
    },
    {
      label: 'Subscription',
      value: 'SKILL_SUBSCRIPTION_INTEGRATION',
    },
    {
      label: 'E-commerce Platform Migration',
      value: 'SKILL_ECOMMERCE_PLATFORM_MIGRATION',
    },
    {
      label: 'Theme Development',
      value: 'SKILL_THEME_DEVELOPMENT',
    },
    {
      label: 'Custom Theme Development',
      value: 'SKILL_CUSTOM_THEME_DEVELOPMENT',
    },
    {
      label: 'Quiz',
      value: 'SKILL_CUSTOM_QUIZ',
    },
    {
      label: 'Cart & Checkout Customization',
      value: 'SKILL_CART_CHECKOUT_CUSTOMIZATION',
    },
    {
      label: 'Landing Pages',
      value: 'SKILL_LANDING_PAGES',
    },
    {
      label: 'Web Accessibility',
      value: 'SKILL_WEB_ACCESSIBILITY',
    },
    {
      label: 'Social Media',
      value: 'SKILL_SOCIAL_MEDIA',
    },
    {
      label: 'Paid Social',
      value: 'SKILL_PAID_SOCIAL',
    },
    {
      label: 'Amazon',
      value: 'SKILL_AMAZON',
    },
    {
      label: 'Paid Search',
      value: 'SKILL_PAID_SEARCH',
    },
    {
      label: 'Front-End Development',
      value: 'SKILL_FRONTEND_DEVELOPMENT',
    },
    {
      label: 'Back-End Development',
      value: 'SKILL_BACKEND_DEVELOPMENT',
    },
    {
      label: 'Systems Architecture',
      value: 'SKILL_SYSTEMS_ARCHITECTURE',
    },
    {
      label: 'Full-Stack Development',
      value: 'SKILL_FULLSTACK_DEVELOPMENT',
    },
    {
      label: 'Packaging',
      value: 'SKILL_PACKAGING',
    },
    {
      label: 'Text Message Marketing',
      value: 'SKILL_TEXT_MESSAGE_MARKETING',
    },
    {
      label: 'Art Direction',
      value: 'SKILL_ART_DIRECTION',
    },
    {
      label: 'Creative Direction',
      value: 'SKILL_CREATIVE_DIRECTION',
    },
    {
      label: 'Affiliate & Referral Marketing',
      value: 'SKILL_AFFILIATE_REFERRAL_MARKETING',
    },
    {
      label: 'Animation',
      value: 'SKILL_ANIMATION',
    },
    {
      label: '3D Product Visualisation',
      value: 'SKILL_3D_PRODUCT_VISUALISATION',
    },
    {
      label: 'Video Editing',
      value: 'SKILL_VIDEO_EDITING',
    },
    {
      label: 'Content Creation',
      value: 'SKILL_CONTENT_CREATION',
    },
    {
      label: '3D Modeling',
      value: 'SKILL_3D_MODELING',
    },
    {
      label: 'Retention Marketing',
      value: 'SKILL_RETENTION_MARKETING',
    },
  ],
  'label',
);

export const CONTINENTS = [
  'North America',
  'Europe',
  'Asia',
  'Africa',
  'Oceania',
  'South America',
];

export const COUNTRIES = [
  'United States of America',
  'Canada',
  'Australia',
  'United Kingdom',
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  "Côte d'Ivoire",
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo (Congo-Brazzaville)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czechia (Czech Republic)',
  'Democratic Republic of the Congo',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini (fmr. "Swaziland")',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Holy See',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar (formerly Burma)',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine State',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States of America',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

export const TIMELINE_OPTIONS = [
  { label: 'Start right away', value: 'TIMELINE_RIGHT_AWAY' },
  { label: 'Start in the next few weeks', value: 'TIMELINE_FEW_WEEKS' },
  { label: 'Start in the next few months', value: 'TIMELINE_FEW_MONTHS' },
];

export const SUPPORT_NEEDED_OPTIONS = [
  { label: 'Ongoing fractional support', value: 'ONGOING' },
  { label: 'Short term project', value: 'SHORT_TERM' },
  { label: 'Full-time', value: 'FULL_TIME' },
];

export const PROJECT_TYPE_OPTIONS = [
  { label: 'Smaller project', value: 'SMALLER' },
  { label: 'Larger project', value: 'LARGER' },
  { label: 'Full website build', value: 'WEBSITE' },
  { label: 'Not sure', value: 'NOT_SURE' },
];

export const TEAM_SIZE_OPTIONS = [
  { label: '1 - 4', value: '1_4' },
  { label: '5 - 10', value: '5_10' },
  { label: '11 - 50', value: '11_50' },
  { label: '51 - 100', value: '51_100' },
  { label: '101 - 500', value: '101_500' },
  { label: '500+', value: '500_PLUS' },
];

export const KPI_GOALS = {
  'account-value': 100000,
  'close-rate': 0.5,
  'completion-rate': 0.95,
  'deadlines-met': 0.5,
  'earnings-escalations': 50000,
  'feedback-rating': 4.7,
  'repeat-rate': 0.4,
};

export const QUOTE_TEMPLATE =
  '{"blocks":[{"key":"4k9r8","text":"Goals / Overview:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":17,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2u1c4","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"f1hmd","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3lncg","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhi2h","text":"Scope:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":6,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2jn04","text":" ","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ef6qr","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ue8d","text":" ","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7in2s","text":"Process:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":8,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"c13mn","text":"","type":"ordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"f5kck","text":"","type":"ordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"p39s","text":"","type":"ordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"708pj","text":"Additional Notes / Out Of Scope:","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":32,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"do3v2","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1phhl","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cij35","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const NRF_TEMPLATE =
  '{"blocks":[{"key":"4k9r8","text":"About Us: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2u1c4","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"47df8","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhi2h","text":"Project Description: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":20,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"24rp1","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5vipq","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5r036","text":"","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fqhot","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"708pj","text":"Project Goal: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":13,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"9lfla","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const EX1_TEMPLATE =
  '{"blocks":[{"key":"4k9r8","text":"About Us: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2u1c4","text":"Hi there, I\'m Charlie, the founder of Melt. We sell CBD-infused bath bombs and are just getting started building this new business.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"47df8","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhi2h","text":"Project Description: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":20,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"24rp1","text":"I recently purchased a Shopify theme from Out of the Sandbox and need help customizing it to fit our needs.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"106qr","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"du76v","text":"Given that we only sell 1 product (with a handful of variations), we want to feature it directly on the home page, so that people don\'t have to click into the product page in order to buy.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3djin","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"11hm1","text":"I\'ll attach the designs below to give you a sense of exactly what we\'re looking for.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fqhot","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"708pj","text":"Project Goal: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":13,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"9lfla","text":"Before we launch, I want to make sure our store feels like our brand and properly highlights our product, as well as maximizes conversion rates.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const EX2_TEMPLATE =
  '{"blocks":[{"key":"4k9r8","text":"About Us: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2u1c4","text":"I work for a digital marketing agency and we have a client that sells subscription boxes with succulents (plants).","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"47df8","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhi2h","text":"Project Description: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":20,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"24rp1","text":"We\'re helping them run Instagram ads and need your help to improve the conversion rates on the site. Specifically we\'re looking to:","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5vipq","text":"Add a slide-in cart, which will enable people to view their items in cart and click to check out from any page on the site.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5r036","text":"Enable up-sells within the cart to encourage people to add an extra item right before they buy.","type":"unordered-list-item","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fqhot","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"708pj","text":"Project Goal: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":13,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"9lfla","text":"It would be great to jump on a Zoom call to hash out the final details. We\'d love to get this done by the end of next week if possible.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const EX3_TEMPLATE =
  '{"blocks":[{"key":"4k9r8","text":"About Us: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":9,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"2u1c4","text":"I\'m the e-commerce manager at an organic cat food brand. We\'ve been around for the past couple years and have been running our store on WordPress with WooCommerce.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"47df8","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fhi2h","text":"Project Description: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":20,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"24rp1","text":"We\'re looking to hire a freelancer to help us migrate the existing site over to Shopify Plus and then handle ongoing changes from there. I\'ll attach our working document below that explains all the functionality that needs to be ported over. We\'re also looking to add a new wholesale channel into the mix as we expand our target customer base.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fqhot","text":" ","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"708pj","text":"Project Goal: ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":13,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"9lfla","text":"Our ideal timeline is to make this happen over the next 2 - 3 months. Looking forward to working together!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export default {
  CONTINENTS,
  COUNTRIES,
  DANGER_ZONE_REMOVAL_REASONS,
  EX1_TEMPLATE,
  EX2_TEMPLATE,
  EX3_TEMPLATE,
  EXPERIENCE_OPTIONS,
  FOCUS_OPTIONS,
  INDUSTRY_OPTIONS,
  KPI_GOALS,
  NRF_TEMPLATE,
  PROBLEM_OPTIONS,
  QUOTE_TEMPLATE,
  SKILL_OPTIONS,
  SKIP_REASONS,
  SUPPORT_EXPERT_ID,
  TIMELINE_OPTIONS,
  TOOL_OPTIONS,
  WEEKLY_CLAIM_LIMIT,
};
